import { connect } from 'react-redux';

import * as CliApp from 'app/entities/CliApp';
import { isLoadingAuths } from 'app/auth/Selectors';
import { currentAppEntity } from 'app/developer-v3/selectors';

import Selector from './Selector';

const mapStateToProps = state => {
  const appEntity = currentAppEntity(state);

  return {
    isLoadingAuths: isLoadingAuths(state),
    logoUrl: CliApp.selectors.imageUrl(appEntity),
  };
};

export default connect(mapStateToProps, null)(Selector);
